export * from './destinations';
export const SEARCH_PARAMS = 'SEARCH_PARAMS';
